module.exports = __webpack_public_path__ + "img/9 filters B-05.84c9aba4.png";